import { thunkTypes } from "../thunk-types.js";
import { createAsyncThunk } from "@reduxjs/toolkit";
//#region src/redux/posts/thunks/get-posts.ts
var getPosts = createAsyncThunk(thunkTypes.GET_POSTS, async (_, { extra }) => {
	return await extra.postRepo.getPosts();
});
//#endregion
export { getPosts };

//# sourceMappingURL=get-posts.js.map